import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _addLineItemsRequest = {};
var _addLineItemsResponse = { cart: '_cart' };
var _addLineItemsToActiveCartRequest = {};
var _addLineItemsToActiveCartResponse = { cart: '_cart' };
var _applyCartActionsRequest = {};
var _applyCartActionsResponse = { cart: '_cart' };
var _cancelActiveCartRequest = {};
var _cancelActiveCartResponse = { cart: '_cart' };
var _cart = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _createCartRequest = { cart: '_cart' };
var _createCartResponse = { cart: '_cart' };
var _createCheckoutRequest = {};
var _createCheckoutResponse = {};
var _deleteCartRequest = {};
var _deleteCartResponse = {};
var _getActiveCartRequest = {};
var _getActiveCartResponse = { cart: '_cart' };
var _getCartRequest = {};
var _getCartResponse = { cart: '_cart' };
var _removeLineItemsRequest = {};
var _removeLineItemsResponse = { cart: '_cart' };
var _updateLineItemsRequest = {};
var _updateLineItemsResponse = { cart: '_cart' };
function resolveWixPremiumCartV1CartServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/premium-cart',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/premium-cart',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/premium-cart',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/premium-cart',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixPremiumCartV1ActiveCartServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/premium-cart',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/premium-cart',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/premium-cart',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/premium-cart',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Get the currently active cart on the context */
export function getActiveCart(payload) {
    var _a = serializer(_getActiveCartRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getActiveCartResponse, { _cart: _cart }).fromJSON;
    function __getActiveCart(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.cart.v1.cart',
            method: 'GET',
            methodFqn: 'wix.premium.cart.v1.ActiveCartService.GetActiveCart',
            url: resolveWixPremiumCartV1ActiveCartServiceUrl({
                protoPath: '/v1/carts/active',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getActiveCart.fromReq = fromReq;
    __getActiveCart.__isAmbassador = true;
    return __getActiveCart;
}
/** Add line items to the currently active cart on the context */
export function addLineItemsToActiveCart(payload) {
    var _a = serializer(_addLineItemsToActiveCartRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addLineItemsToActiveCartResponse, {
        _cart: _cart,
    }).fromJSON;
    function __addLineItemsToActiveCart(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.cart.v1.cart',
            method: 'PATCH',
            methodFqn: 'wix.premium.cart.v1.ActiveCartService.AddLineItemsToActiveCart',
            url: resolveWixPremiumCartV1ActiveCartServiceUrl({
                protoPath: '/v1/carts/active/add-items',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addLineItemsToActiveCart.fromReq = fromReq;
    __addLineItemsToActiveCart.__isAmbassador = true;
    return __addLineItemsToActiveCart;
}
/** Cancel the currently active cart on the context */
export function cancelActiveCart(payload) {
    var _a = serializer(_cancelActiveCartRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cancelActiveCartResponse, {
        _cart: _cart,
    }).fromJSON;
    function __cancelActiveCart(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.cart.v1.cart',
            method: 'POST',
            methodFqn: 'wix.premium.cart.v1.ActiveCartService.CancelActiveCart',
            url: resolveWixPremiumCartV1ActiveCartServiceUrl({
                protoPath: '/v1/carts/active/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'POST',
                    url: resolveWixPremiumCartV1ActiveCartServiceUrl({
                        protoPath: '/v1/carts/active/cancel',
                        data: serializedData,
                        host: host,
                    }),
                    data: serializedData,
                },
            ],
        };
        return metadata;
    }
    __cancelActiveCart.fromReq = fromReq;
    __cancelActiveCart.__isAmbassador = true;
    return __cancelActiveCart;
}
/** Creates a Cart */
export function createCart(payload) {
    var _a = serializer(_createCartRequest, {
        _cart: _cart,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createCartResponse, { _cart: _cart }).fromJSON;
    function __createCart(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.cart.v1.cart',
            method: 'POST',
            methodFqn: 'wix.premium.cart.v1.CartService.CreateCart',
            url: resolveWixPremiumCartV1CartServiceUrl({
                protoPath: '/v1/carts',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createCart.fromReq = fromReq;
    __createCart.__isAmbassador = true;
    return __createCart;
}
/** Retrieves a Cart */
export function getCart(payload) {
    var _a = serializer(_getCartRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCartResponse, { _cart: _cart }).fromJSON;
    function __getCart(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.cart.v1.cart',
            method: 'GET',
            methodFqn: 'wix.premium.cart.v1.CartService.GetCart',
            url: resolveWixPremiumCartV1CartServiceUrl({
                protoPath: '/v1/carts/{cartId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCart.fromReq = fromReq;
    __getCart.__isAmbassador = true;
    return __getCart;
}
/** Deletes a Cart */
export function deleteCart(payload) {
    var _a = serializer(_deleteCartRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteCartResponse, {}).fromJSON;
    function __deleteCart(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.cart.v1.cart',
            method: 'DELETE',
            methodFqn: 'wix.premium.cart.v1.CartService.DeleteCart',
            url: resolveWixPremiumCartV1CartServiceUrl({
                protoPath: '/v1/carts/{cartId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteCart.fromReq = fromReq;
    __deleteCart.__isAmbassador = true;
    return __deleteCart;
}
/** Adds Line Items to Cart */
export function addLineItems(payload) {
    var _a = serializer(_addLineItemsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addLineItemsResponse, { _cart: _cart }).fromJSON;
    function __addLineItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.cart.v1.cart',
            method: 'PATCH',
            methodFqn: 'wix.premium.cart.v1.CartService.AddLineItems',
            url: resolveWixPremiumCartV1CartServiceUrl({
                protoPath: '/v1/carts/add-items/{cartId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addLineItems.fromReq = fromReq;
    __addLineItems.__isAmbassador = true;
    return __addLineItems;
}
/** Updates Line Items in Cart */
export function updateLineItems(payload) {
    var _a = serializer(_updateLineItemsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateLineItemsResponse, { _cart: _cart }).fromJSON;
    function __updateLineItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.cart.v1.cart',
            method: 'PATCH',
            methodFqn: 'wix.premium.cart.v1.CartService.UpdateLineItems',
            url: resolveWixPremiumCartV1CartServiceUrl({
                protoPath: '/v1/carts/update-items/{cartId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateLineItems.fromReq = fromReq;
    __updateLineItems.__isAmbassador = true;
    return __updateLineItems;
}
/** Removes Line Items from Cart */
export function removeLineItems(payload) {
    var _a = serializer(_removeLineItemsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeLineItemsResponse, { _cart: _cart }).fromJSON;
    function __removeLineItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.cart.v1.cart',
            method: 'PATCH',
            methodFqn: 'wix.premium.cart.v1.CartService.RemoveLineItems',
            url: resolveWixPremiumCartV1CartServiceUrl({
                protoPath: '/v1/carts/remove-items/{cartId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeLineItems.fromReq = fromReq;
    __removeLineItems.__isAmbassador = true;
    return __removeLineItems;
}
/** Applies Cart Actions on Cart */
export function applyCartActions(payload) {
    var _a = serializer(_applyCartActionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_applyCartActionsResponse, {
        _cart: _cart,
    }).fromJSON;
    function __applyCartActions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.cart.v1.cart',
            method: 'PATCH',
            methodFqn: 'wix.premium.cart.v1.CartService.ApplyCartActions',
            url: resolveWixPremiumCartV1CartServiceUrl({
                protoPath: '/v1/carts/apply-actions/{cartId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __applyCartActions.fromReq = fromReq;
    __applyCartActions.__isAmbassador = true;
    return __applyCartActions;
}
/** Creates a checkout order session */
export function createCheckout(payload) {
    var _a = serializer(_createCheckoutRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createCheckoutResponse, {}).fromJSON;
    function __createCheckout(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.cart.v1.cart',
            method: 'POST',
            methodFqn: 'wix.premium.cart.v1.CartService.CreateCheckout',
            url: resolveWixPremiumCartV1CartServiceUrl({
                protoPath: '/v1/carts/create-checkout/{cartId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createCheckout.fromReq = fromReq;
    __createCheckout.__isAmbassador = true;
    return __createCheckout;
}
//# sourceMappingURL=http.impl.js.map